// Dentro de um iframe de outro site (ex.: prévia do customizador no dashboard), navegadores que bloqueiam
// armazenamento de terceiros fazem window.localStorage/sessionStorage lançar SecurityError, o que derruba o checkout
// inteiro. Nesse caso troca por um armazenamento em memória (só vale enquanto a página estiver aberta).

class MemoryStorage implements Storage {
    private items = new Map<string, string>();

    get length(): number {
        return this.items.size;
    }

    clear(): void {
        this.items.clear();
    }

    getItem(key: string): string | null {
        return this.items.has(key) ? (this.items.get(key) as string) : null;
    }

    key(index: number): string | null {
        return Array.from(this.items.keys())[index] ?? null;
    }

    removeItem(key: string): void {
        this.items.delete(key);
    }

    setItem(key: string, value: string): void {
        this.items.set(key, String(value));
    }
}

function ensureStorage(name: 'localStorage' | 'sessionStorage'): void {
    try {
        const storage = window[name];
        const probe = '__hoopay_storage_probe__';
        storage.setItem(probe, probe);
        storage.removeItem(probe);
    } catch {
        try {
            Object.defineProperty(window, name, { value: new MemoryStorage(), configurable: true });
        } catch {
            // sem como substituir: segue como está
        }
    }
}

ensureStorage('localStorage');
ensureStorage('sessionStorage');
